import { Box } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useAgencySelector from '@hooks/useAgencySelector'
import { useRelations } from '@hooks/useCampaign'

import { UseFormPayload } from '@domain-group/react-hooks'

import { CampaignModel } from '@models/types'
import type { UseEntityCustomFieldsFormPayload } from '@hooks/useEntityCustomFieldsForm'

import EntityCustomFields from '@components/EntityCustomFields'

import AgencyDetails from '../AgencyDetails'
import CampaignStatus from '../CampaignStatus'
import ExtraDetails from '../ExtraDetails'
import LandDetails from '../LandDetails'
import ListingDetails from '../ListingDetails'
import PropertyAddress from '../PropertyAddress'
import PropertyFeatures from '../PropertyFeatures'

interface DetailsProps {
  campaign: CampaignModel,
  campaignFormPayload: UseFormPayload,
  customFieldsForm: UseEntityCustomFieldsFormPayload,
}

const Details = (props: DetailsProps) => {
  const { campaign, campaignFormPayload, customFieldsForm } = props

  const { hasMultipleAgencies, selectedAgency } = useAgencySelector()

  const { brand } = useRelations(campaign)

  const supportsCrossAgencyCollaboration = digObject(brand, 'options.cross_agency_collaboration', false)

  return (
    <Box flexDirection="column">
      {(hasMultipleAgencies || supportsCrossAgencyCollaboration) && (
        <AgencyDetails
          campaignForm={campaignFormPayload}
          supportsCrossAgencyCollaboration={supportsCrossAgencyCollaboration}
        />
      )}

      <PropertyAddress agency={selectedAgency} campaignForm={campaignFormPayload} />

      <PropertyFeatures campaignForm={campaignFormPayload} />

      <CampaignStatus campaignForm={campaignFormPayload} />

      <ListingDetails campaignForm={campaignFormPayload} />

      <LandDetails campaignForm={campaignFormPayload} />

      <ExtraDetails campaignForm={campaignFormPayload} />

      <EntityCustomFields customFieldsForm={customFieldsForm} />
    </Box>
  )
}

export default Details
